import a from "./utils/hslToRgb";
export default (function (b) {
  var c = a(b.h, b.s, b.l);
  return "rgba(" + [c[0], c[1], c[2], b.a].join(",") + ")";
});